import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrPipeIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M7.9993 1.28027C8.39694 1.28027 8.7193 1.60263 8.7193 2.00027L8.7193 14.0003C8.7193 14.3979 8.39694 14.7203 7.9993 14.7203C7.60165 14.7203 7.2793 14.3979 7.2793 14.0003L7.2793 2.00027C7.2793 1.60263 7.60165 1.28027 7.9993 1.28027Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrPipeIconComponent;
